import React from 'react';
import { useBillingContext } from './billing.context';
import { Button, useMobileFixedEditActionStyles } from '@uplift/ui-v2';
import { Box } from '@mui/material';
import { useUpBreakpoint } from '@uplift/hooks';

export const BillingPaymentButton: React.VFC = () => {
  const { handlePayBalanceClick, showPayBalanceStickyButton } = useBillingContext();
  const { classes: fixedActionClasses } = useMobileFixedEditActionStyles();
  const isSmUp = useUpBreakpoint('sm');

  if (isSmUp || !showPayBalanceStickyButton) return null;

  return (
    <Box className={fixedActionClasses.container}>
      <Button
        variant="contained"
        color="secondary"
        onClick={handlePayBalanceClick}
      >
        Pay Balance
      </Button>
    </Box>
  );
};
